import { render, staticRenderFns } from "./SQuesFortyFour.vue?vue&type=template&id=1180079c&"
import script from "./SQuesFortyFour.vue?vue&type=script&lang=js&"
export * from "./SQuesFortyFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports